import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import { setToken } from "./app/authSlice";
import { useDispatch, useSelector } from "react-redux";
import initializeApp from "./app/init";
// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const UpdateLicence = lazy(() => import("./pages/UpdateLicence"));

// Defer auth checks to effect to avoid running at module load
// Initializing different libraries
initializeApp();
// Check for login and initialize axios
const token = checkAuth();



function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
    if (token) {
      dispatch(setToken(token));
    }

  }, []);

  const tokenForRoute = localStorage.getItem("token");
  const user = useSelector((state) => state.auth.user);
  const role = user?.role;

  return (
    <>
      <Router>
        <Routes>
          <Route path="/add-licence" element={<UpdateLicence />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app/*" element={<Layout />} />

          {/* Default redirect when hitting just domain root `/` */}
          <Route
            path="/"
            element={
              <Navigate to={tokenForRoute ? role==='administrator'? "/app/pushers" :"/app/operator-devices" : "/login"} replace />
            }
          />

          {/* 404 fallback */}
          <Route path="*" element={<Navigate to="/app/404" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
